export type ContactSegment = "contacts" | "superfans" | "supporters" | "active";

export const CONTACT_SEGMENTS: ContactSegment[] = [
  "superfans",
  "supporters",
  "active",
  "contacts",
];

export function getActiveWithin90DaysCutoff(): Date {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - 90);
  cutoff.setHours(0, 0, 0, 0);
  return cutoff;
}

export function contactSegmentToQueryPart(
  segment: ContactSegment,
): Record<string, unknown> | null {
  switch (segment) {
    case "contacts":
      return null;
    case "superfans":
      return { numPurchases: { $gt: 1 } };
    case "supporters":
      return { numPurchases: { $gt: 0 } };
    case "active":
      return { lastActive: { $gte: getActiveWithin90DaysCutoff() } };
  }
}

export function parseContactSegmentParam(
  value: string | null,
): ContactSegment {
  if (
    value === "superfans" ||
    value === "supporters" ||
    value === "active" ||
    value === "contacts"
  ) {
    return value;
  }
  return "contacts";
}
